export default "__VITE_ASSET__DlrPdzG1__"